import { FileType } from "../__generated__/FileUploadAreaMutation.graphql";

//const maxBatchSize = 10;
// function reasonMessage(reason: ErrorReason): string {
//   switch (reason) {
//     case "unknown":
//       return "Något gick fel. Försök igen.";
//     case "size":
//       return "Filen är för stor. Maximal filstorlek är 10MB.";
//     case "tooMany":
//       return (
//         "Du har för många filer. Ladda upp max " +
//         maxBatchSize +
//         " filer per gång."
//       );
//     case "type":
//       return "Filtypen är inte tillåten. Endast PDF, Word och Excel är tillåtna.";
//   }
// }
export function mimeToType(type: string): FileType | undefined {
  switch (type) {
    case "application/pdf":
      return "PDF";
    case "application/msword":
      return "DOC";
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return "DOCX";
    case "application/vnd.ms-excel":
      return "XLS";
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return "XLSX";
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return "PPTX";
    case "application/mspowerpoint":
    case "application/powerpoint":
    case "application/vnd.ms-powerpoint":
      return "PPT";

    default:
      return undefined;
  }
}
